import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { RootContainerProps as Props } from './types';
import { useSuggestionSearchBarContext } from '../../context';

export const RootContainer = memo(({ className, children }: Props) => {
  const { getRootProps } = useSuggestionSearchBarContext();

  return (
    <Styled.Wrapper
      className={classnames('SuggestionSearchBar', className)}
      sx={SX.root}
      {...getRootProps()}
    >
      {children}
    </Styled.Wrapper>
  );
});

RootContainer.displayName = 'RootContainer';
